<template>
    <div class="tabs">
        <menu>
            <span
                    v-for="m, i in menu"
                    v-on:click="onMenuClick(i)"
                    v-bind:class="{ 'active': currentIndex == i }">{{ m }}</span>
        </menu>
        <div class="tab-content" :class="'index' + currentIndex"><slot></slot></div>
    </div>
</template>

<script>
    export default {
        props: {
            menu: {
                type: Array,
                required: false
            }
        },
        data: () => ({
            currentIndex: 0
        }),
        methods: {
            onMenuClick(i){
                this.currentIndex = i;
            }
        }
    }
</script>